import React from 'react'

export default function WhatsAppStatusIndicator() {
  return null
}
